import React, { type JSX } from 'react';
import { Image } from '../../../../../../wag-react/next-components/image';
import { BodyObject } from '../../../../../../types/api';
import { ArticleBlockquote } from '../../../../../../components/ArticleBlockquote';
import { Markdown } from '../../../../../../components/Markdown';
import { PinterestImage } from '../../../../../../components/PinterestImage';
import { ScrollableElementContainer } from '../../../../../../components/ScrollableElementContainer';
import { SectionHeading } from '../../../../../../components/SectionHeading';
import { WellnessArticleOverview } from '../WellnessArticleOverview';
import { WellnessCmsComponents } from '../../../../../../constants/app';
import { LazyYoutube } from '../../../../../../wag-react/components/lazyload/LazyYoutube';
import { PetInsurerWithFeaturedProviders } from '../../../../../../wag-react/components/pet-insurer-cta-section';
export type ItemProps = {
  item: BodyObject;
};
export const BodyContainerComponentsMapping = ({
  // Do not structure as it will lose the discriminated union from TypeScript
  item
}: ItemProps): JSX.Element | null => {
  /* Render different components
  based on the  api response */

  if (item.type === 'overview') {
    return <WellnessArticleOverview value={item.value} />;
  }
  if (item.type === 'header') {
    return <SectionHeading color="#474747" variant="h2" textAlign="left">
        {item.value}
      </SectionHeading>;
  }
  if (item.type === 'subheader') {
    return <ScrollableElementContainer id={item.id}>
        <SectionHeading display="grid" justifySelf="start" textAlign="left" color="#474747" variant="h3" my="0px" py="0px">
          {item.value}
        </SectionHeading>
      </ScrollableElementContainer>;
  }
  if (item.type === 'paragraph') {
    return <Markdown version="react-markdown">
        {item.value}
      </Markdown>;
  }
  if (item.type === 'image' || item.type === 'image_v2') {
    return <Image width={1} borderRadius="8px" my="40px" src={item.image} alt={item.altText} />;
  }
  if (item.type === 'infographic') {
    return <PinterestImage url={item.image} imageProps={{
      alt: item.altText,
      width: ['344px', '600px'],
      height: ['344px', '600px']
    }} />;
  }
  if (item.type === 'video_link') {
    return <LazyYoutube src={item.url} my={['24px', '32px']} />;
  }
  if (item.type === 'blockquote') {
    return <ArticleBlockquote value={item.value} />;
  }
  if (item.type === 'component') {
    // Use for enabling or disabling components so that we can toggle them individually
    if (!item.props.isEnabled) {
      return null;
    }

    /**
     * TODO - create a better mapping once we have more data to support it
     */
    if (item.component === WellnessCmsComponents.PetInsurerWithFeaturedProviders) {
      return <PetInsurerWithFeaturedProviders {...item.props as unknown as Record<string, unknown>}
      /**
       * To trigger the fallback prop values, pass an `undefined`
       * and not an empty string or null
       *
       * This is a front-end responsibility and behavior
       */ heading={item.props.heading as string || undefined} subHeading={item.props.subHeading as string || undefined} />;
    }
  }
  return null;
};